export const getSkywalkerSearchParams = (response, pageName) => {
  const {
    fromDateTime,
    toDateTime,
    fromCity,
    toCity,
    paxCount,
    cabinClass,
    trainNumber,
  } = response;

  const searchParams = {
    lastSearchContext: {
      searchContext: {
        lob: 'rails',
        lobCategory: 'rails',
        ...(fromDateTime && {
          fromDateTime: {
            str: fromDateTime || 'dd-mm-yyyy HH:mm:ss',
          },
        }),
        ...(toDateTime && {
          toDateTime: {
            str: toDateTime || 'dd-mm-yyyy HH:mm:ss',
          },
        }),
        from: {
          lobCity: fromCity,
          lobCountry: 'India',
          countryCode: 'IN',
        },
        to: {
          lobCity: toCity,
          lobCountry: 'India',
          countryCode: 'IN',
        },
        ...(paxCount && {
          pax: [
            {
              count: paxCount,
            },
          ],
        }),
        ...(cabinClass && { cabinClass: cabinClass || 'SL/2S/1A/2A/3A/EA/EC/FC/3E/CC' }),
        journeyType: 'OW',
        timestamp: new Date().getTime(),
      },
      lastPageViewed: pageName,
      // pageName:"review",
      // products:["trainnumber"]
    },
  };

  if (pageName == 'review' && searchParams.lastSearchContext) {
    searchParams.lastSearchContext.pageName = pageName;
    trainNumber && (searchParams.lastSearchContext.products = [trainNumber]);
  }

  return searchParams;
};

export const getSectorInformation = (response, pageName) => {
  const { fromCity, toCity, trainNumber } = response;
  const sectorDetails = {
    lob: 'rails',
    sector: `${fromCity}-${toCity}`,
    pageName: pageName.toLowerCase(),
    products: [trainNumber],
  };
  return sectorDetails;
};
